/**
 * Signalement en cours de saisie (front public). Reprend les champs du service
 * `Report` de l'ancien OSER.
 */
export interface ReportData {
  // Type
  incident_type: string;
  location_type: string;
  // Détail
  sub_category_incident: string | null;
  report_date: Date;
  description: string;
  measures: string;
  golden_rule: string | null;
  stopcard: boolean;
  picture: File | null;
  // Localisation
  location: string;
  lat: number | null;
  lng: number | null;
}

export const EMPTY_REPORT: ReportData = {
  incident_type: '',
  location_type: '',
  sub_category_incident: null,
  report_date: new Date(),
  description: '',
  measures: '',
  golden_rule: null,
  stopcard: false,
  picture: null,
  location: '',
  lat: null,
  lng: null,
};

// Les 12 « règles qui sauvent » OSER (clés i18n entities.golden_rule.<key>.* + image <key>.png).
export const GOLDEN_RULES = [
  'high-risk',
  'traffic',
  'body-meca',
  'equip-protection',
  'work-licence',
  'lifting',
  'energy-systems',
  'closed-spaces',
  'digging',
  'heights',
  'changes',
  'multi-activity',
] as const;

// Types de signalement OSER : en prod, seul `event` est actif, avec ses lieux.
export const INCIDENT_TYPES = ['event'] as const;

export const LOCATION_TYPES_BY_INCIDENT: Record<string, string[]> = {
  event: ['site', 'station', 'head_office', 'transport', 'intelligence', 'other'],
};

// Sous-catégories d'incident (clés i18n entities.sub_category_incident.*).
export const SUB_CATEGORY_INCIDENTS = [
  'ABSENCE_PERMIS_TRAVAIL',
  'ABSENCE_CONSIGNATION',
  'NON_PORT',
  'RISQUE_CHUTE',
  'EQUIPEMENT_NON_CONFORME',
  'LIEU_TRAVAIL',
  'FUITE_CONFINEMENT',
  'FEU',
  'TOTAL_IMAGE_PREJUDICE',
  'SURETE',
  'POLLUTION',
  'AUTRES',
  'MAUVAIS_COMPORTEMENT',
  'MAV_TEMPS',
  'MAV_ETAT_ROUTE',
  'TRAVAUX_ROUTE',
  'SIGNALISATION_ROUTE',
  'ABSENCE_SCELLES',
  'RENVERSEMENT',
  'COLLISION',
  'INNOVATION',
  'INTELLIGENCE_COMMERCIALE',
  'OUTILS_INADEQUATS',
  'ABSENCE_SUPERVISION',
] as const;
